import React from "react";
import { Modal, Spinner } from "react-bootstrap";

export const LoadingModal = ({ isLoading, message = "Processing..." }) => {
  return (
    <Modal
      show={isLoading}
      backdrop="static"   // prevents closing by clicking outside
      keyboard={false}    // prevents closing with ESC
      centered
      size="sm"
    >
      <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
        <Spinner animation="grow" role="status" variant="info" className="mb-2" size="md" />
        <strong>{message}</strong>
      </Modal.Body>
    </Modal>
  );
};
